// Test IDs for the home / landing feature. Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const HOME = {
  emergentLink: 'home-emergent-link',
  searchInput: 'home-search-input',
  newsletterEmailInput: 'home-newsletter-email-input',
  newsletterSubmitButton: 'home-newsletter-submit-button',
  feedbackTrigger: 'home-feedback-trigger',
  feedbackModal: 'home-feedback-modal',
  feedbackEmailInput: 'home-feedback-email-input',
  feedbackMessageInput: 'home-feedback-message-input',
  feedbackSubmitButton: 'home-feedback-submit-button',
};
